var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.1824 0H3.78227C2.22759 0 0.967407 1.25922 0.967407 2.81271V36.1873C0.967407 37.7408 2.22759 39 3.78227 39H37.1824C38.7371 39 39.9973 37.7408 39.9973 36.1873V2.81271C39.9973 1.25922 38.7371 0 37.1824 0ZM14.8115 29.4785H10.0588V15.1906H14.8115V29.4785ZM12.4353 13.2396H12.4043C10.8094 13.2396 9.77796 12.1426 9.77796 10.7715C9.77796 9.36944 10.841 8.30273 12.4669 8.30273C14.0927 8.30273 15.0932 9.36944 15.1242 10.7715C15.1242 12.1426 14.0927 13.2396 12.4353 13.2396ZM31.949 29.4785H27.1969V21.8348C27.1969 19.9139 26.5087 18.6038 24.7891 18.6038C23.4762 18.6038 22.6942 19.4875 22.3506 20.3406C22.2249 20.6459 22.1943 21.0725 22.1943 21.4995V29.4785H17.4418C17.4418 29.4785 17.504 16.5311 17.4418 15.1906H22.1943V17.2137C22.8258 16.2401 23.9559 14.8553 26.4774 14.8553C29.6044 14.8553 31.949 16.8974 31.949 21.2859V29.4785Z",
    fill: "#214D49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.0299,
    height: 39,
    fill: "white",
    transform: "translate(0.967407)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.1a11f6e9e1c7a797782a68218c4e1bdb.svg";
export { ForwardRef as ReactComponent };